import React from "react";
const ArrowLeft = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path d="M796.32 90.496L705.824 0 208 497.792l4.352 4.352-4.352 4.352 497.792 497.824 90.528-90.528L384.64 502.144 796.32 90.496z" />
  </svg>
);
export default ArrowLeft;
